module.exports = __webpack_public_path__ + "img/screen-2-step-2.e1cd01e3.png";